import alt from "../alt";
import indexBy from "lodash/keyBy";
import extend from "lodash/extend";
import values from "lodash/values";
import CreditActions from "../actions/CreditActions";
import CreditUtil from "../utils/CreditUtil";
import UserStore from "../stores/UserStore";

class CreditStore {
  constructor() {
    this.bindActions(CreditActions);

    this.state = {
      creditRecords: {}
    };

    this.exportPublicMethods({
      getCreditRecordByPerson: this.getCreditRecordByPerson.bind(this)
    });
  }

  getCreditRecordByPerson({ person, event_bucket }) {
    return this.state.creditRecords[`${person}--${event_bucket}`];
  }

  onFetchCreditRecordForPerson({ person, event_bucket }) {
    this.setState({ isFetching: true });
    CreditUtil.fetchCreditsForPerson(
      UserStore.getState().apiKey,
      person,
      event_bucket
    )
      .then(data => {
        let records = Object.assign(this.state.creditRecords, {
          [`${person}--${event_bucket}`]: data
        });
        this.setState({
          isFetching: false,
          creditRecords: records
        });
      })
      .catch(CreditActions.fetchFailed);
  }

  onAddCreditRecordEvent(opts) {
    this.setState({ isEditing: true });
    let { person, ...rest } = opts;
    CreditUtil.addCreditRecordEvent(UserStore.getState().apiKey, person, rest)
      .then(data => {
        let records = Object.assign(this.state.creditRecords, {
          [`${person}--${rest.event_bucket}`]: data
        });
        this.setState({
          isEditing: false,
          creditRecords: records
        });
      })
      .catch(CreditActions.editFailed);
  }

  onFetchFailed(e) {
    window.alert(`Fetching credits failed: ${e.message}`);
  }

  onEditFailed(e) {
    window.alert(`Updating credits failed: ${e.message}`);
  }
}

export default alt.createStore(CreditStore, "CreditStore");



// WEBPACK FOOTER //
// ./src/app/stores/CreditStore.js